var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section",class:[("section--" + _vm.type)],style:({'max-height': _vm.maxHeight ? (_vm.maxHeight + 'px') : 'auto'}),attrs:{"id":_vm.id}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }